import { ShoppingCart, ArrowLeft, GraduationCap, Tv, BookOpen, Flame, Facebook, Twitter, Linkedin, MessageCircle, Mail, Copy, CheckCircle2, Share2, Send, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import "./StoryPage.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SITE_URL = "https://africanamericanxperience.com";
const STORY_URL = `${SITE_URL}/story`;
const STORY_HEADLINE =
  "I went to an HBCU because of a TV show. Now I'm publishing the names schools won't teach.";
const STORY_BODY =
  "N.J. Griffin's open letter on why he's self-publishing Stones the Builder Refused — 50 African Americans per volume, 5 collector's volumes. Volume I is shipping now.";

function StoryShare() {
  const [copied, setCopied] = useState(false);
  const enc = encodeURIComponent;
  const links = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(STORY_URL)}&quote=${enc(STORY_HEADLINE)}`,
    twitter: `https://twitter.com/intent/tweet?url=${enc(STORY_URL)}&text=${enc(STORY_HEADLINE)}&hashtags=${enc("BlackHistory,HBCU,AAX,StonesTheBuilderRefused")}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(STORY_URL)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${enc(STORY_HEADLINE + " " + STORY_URL)}`,
    email: `mailto:?subject=${enc(STORY_HEADLINE)}&body=${enc(STORY_BODY + "\n\n" + STORY_URL)}`,
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(STORY_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch { /* clipboard not available */ }
  };
  return (
    <div className="story-share" data-testid="story-share">
      <span className="story-share-label">
        <Share2 size={14} /> If this hit — share it
      </span>
      <div className="story-share-btns">
        <a href={links.facebook} target="_blank" rel="noreferrer noopener" data-testid="story-share-facebook">
          <Facebook size={15} /> Facebook
        </a>
        <a href={links.twitter} target="_blank" rel="noreferrer noopener" data-testid="story-share-x">
          <Twitter size={15} /> X
        </a>
        <a href={links.whatsapp} target="_blank" rel="noreferrer noopener" data-testid="story-share-whatsapp">
          <MessageCircle size={15} /> WhatsApp
        </a>
        <a href={links.linkedin} target="_blank" rel="noreferrer noopener" data-testid="story-share-linkedin">
          <Linkedin size={15} /> LinkedIn
        </a>
        <a href={links.email} data-testid="story-share-email">
          <Mail size={15} /> Email
        </a>
        <button onClick={copy} className={copied ? "copied" : ""} data-testid="story-share-copy">
          {copied ? <CheckCircle2 size={15} /> : <Copy size={15} />}
          {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </div>
  );
}

function ContactSection() {
  const [form, setForm] = useState({
    name: "", email: "", inquiry_type: "general", subject: "", message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setError("Please fill in your name, email, and message.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSubmitted(true);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Couldn't send. Please try again or email nikita_griffin2000@yahoo.com directly.";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <section className="story-contact" data-testid="story-contact">
        <div className="story-contact-success" data-testid="contact-success">
          <CheckCircle2 size={48} />
          <h3>Message sent.</h3>
          <p>
            Thank you — N.J. will read this personally and reply to you at{" "}
            <b>{form.email}</b> within 1–2 days.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="story-contact" data-testid="story-contact">
      <div className="story-contact-head">
        <h2>Leave a message</h2>
        <p>
          Press inquiry · bulk order for a school, church, or library · speaking
          request · or just want to say hello? Drop a note. I read every one.
        </p>
      </div>
      <form onSubmit={submit} className="story-contact-form" data-testid="contact-form">
        <div className="story-contact-row">
          <label>
            Name
            <input
              type="text" value={form.name} onChange={update("name")}
              placeholder="Your full name" required
              data-testid="contact-name-input"
            />
          </label>
          <label>
            Email
            <input
              type="email" value={form.email} onChange={update("email")}
              placeholder="you@example.com" required
              data-testid="contact-email-input"
            />
          </label>
        </div>
        <label>
          I&apos;m reaching out about
          <select
            value={form.inquiry_type} onChange={update("inquiry_type")}
            data-testid="contact-type-select"
          >
            <option value="general">General question</option>
            <option value="press">Press / media inquiry</option>
            <option value="bulk">Bulk order (school, church, library, alumni chapter)</option>
            <option value="speaking">Speaking engagement / interview</option>
            <option value="educator">Free educator preview chapter</option>
            <option value="other">Something else</option>
          </select>
        </label>
        <label>
          Subject (optional)
          <input
            type="text" value={form.subject} onChange={update("subject")}
            placeholder="Short headline so I know what this is about"
            data-testid="contact-subject-input"
          />
        </label>
        <label>
          Message
          <textarea
            rows={6} value={form.message} onChange={update("message")}
            placeholder="Tell me what you need. Include outlet name + deadline if this is press, or copy count + ship-to city if it's a bulk order."
            required
            data-testid="contact-message-input"
          />
        </label>
        {error && <p className="story-contact-error" data-testid="contact-error">{error}</p>}
        <button
          type="submit" className="btn btn-gold btn-lg"
          disabled={submitting}
          data-testid="contact-submit-btn"
        >
          {submitting ? <Loader2 size={18} className="spin" /> : <Send size={18} />}
          {submitting ? "Sending…" : "Send message"}
        </button>
        <p className="story-contact-note">
          Or email N.J. directly: <a href="mailto:press@africanamericanxperience.com">press@africanamericanxperience.com</a>
        </p>
      </form>
    </section>
  );
}

export default function StoryPage() {
  return (
    <div className="story-page" data-testid="story-page">
      <nav className="story-nav">
        <Link to="/" className="story-back" data-testid="story-back-link">
          <ArrowLeft size={16} /> Back to the book
        </Link>
        <a href="https://africanamericanxperience.com" className="story-brand">
          African American <span className="accent-gold">Xperience</span>
        </a>
      </nav>

      <header className="story-hero">
        <div className="story-hero-inner">
          <div className="story-eyebrow">
            <Flame size={14} /> A letter from the founder
          </div>
          <h1 className="story-title">
            I went to an HBCU
            <br />
            because of <span className="accent-gold">a TV show.</span>
          </h1>
          <p className="story-deck">
            And I’m publishing this five-volume series because the country
            that raised me is trying to make sure the next generation never
            even hears the names.
          </p>
          <p className="story-byline">
            — <b>N.J. Griffin</b>, Founder · African American Xperience
          </p>
        </div>
      </header>

      <main className="story-body">
        <article className="story-prose">

          <p>I’ll be straight with you.</p>

          <p>
            I didn’t learn about Historically Black Colleges and Universities
            because anyone in my K-12 classroom taught me about them. I learned
            about them because of <i>A Different World</i>. Because of
            <i> The Cosby Show</i>. Because Whitley, Dwayne, Ron and the rest
            of that Hillman College crew made it look like there was a place
            where being Black and being brilliant lived in the same sentence
            — before I had the words for why I needed to be in that sentence
            too.
          </p>

          <p className="pull-quote">
            <Tv size={20} />
            <span>
              A TV show told me about my own people. That tells you everything you need to know about what the school system <i>didn&apos;t</i>.
            </span>
          </p>

          <p>
            So I went to <b>Morris College</b> in Sumter, South Carolina —
            graduated with degrees in <b>Criminal Justice</b> and <b>Psychology</b>.
            And it changed everything.
          </p>

          <p>
            But here&apos;s the part most people don&apos;t hear: Morris put me
            in the room. The deep learning of Black history? I did that
            myself. Library after library. Name after name. Most nights it
            was just me, a search bar, and a list of people the textbooks
            would rather you didn&apos;t know existed. I learned that the
            people who built this country with their hands, their songs,
            their sermons, and their science — most of their names were
            quietly left off the page. Not by accident. By design.
          </p>

          <p className="story-callout-grads">
            And let me say this clearly:
            <br />
            <b>This is for every college graduate</b> — every HBCU brother
            and sister, every state college and public university alum, every
            community college grad — who knows the cost of finally being told
            <i> the rest of the story.</i> You&apos;re part of why this exists.
          </p>

          <p>
            <span className="drop-cap">N</span>ow I’m watching that page get
            smaller in real time. Across the country, school boards are
            pulling Black history out of the classroom. Books are being
            challenged. Curriculum is being ”neutralized.” A child born in
            2026 is being raised to think the American story has a hole in
            it where their great-grandfather’s name used to be.
          </p>

          <p>
            <b>I refuse to let that happen on our watch.</b>
          </p>

          <p>So I sat down and started writing.</p>

          <div className="story-divider">
            <span></span>
            <BookOpen size={16} />
            <span></span>
          </div>

          <h2>What we built</h2>

          <p>
            <i>Stones the Builder Refused</i> is a five-volume collector’s
            library. Volume I is in print today. It holds 50 lives the
            government would rather you didn’t learn — inventors, organizers,
            athletes, scientists, soldiers, poets, sharecroppers, surgeons,
            cornerstones.
          </p>

          <p>
            The stones the builder refused — who became the chief cornerstones.
          </p>

          <p>
            But this isn&apos;t just one book. <b>African American Xperience</b> is
            a publishing house with a five-volume collector&apos;s library coming —
            fifty lives per volume, two hundred and fifty in total. A complete
            home library of an American story that almost went unwritten.
          </p>

          <p>
            Volume I is shipping today. The seed is in the ground.
          </p>

          <ul className="story-pillars">
            <li>
              <BookOpen size={20} />
              <b>Volume I — available now.</b> Fifty African American lives.
              $1 digital download. $24.99 hardcover printed and shipped to
              your door.
            </li>
            <li>
              <GraduationCap size={20} />
              <b>Five collector&apos;s volumes.</b> 250 lives total. The full
              library every Black household can pass to the next generation.
              Volumes II through V coming.
            </li>
            <li>
              <Flame size={20} />
              <b>Free educator preview.</b> Teachers and homeschool parents
              can request a sample chapter for classroom use. Email-only.
            </li>
            <li>
              <Tv size={20} />
              <b>A movement that outlasts a textbook ban.</b> When they take
              it out of the classroom, we put it in the home — one collector&apos;s
              edition at a time.
            </li>
          </ul>

          <div className="story-divider">
            <span></span>
            <Flame size={16} />
            <span></span>
          </div>

          <h2>This was made for you</h2>

          <p>
            If you’ve ever watched a teacher dance around a name they didn’t
            have the freedom to teach —
          </p>
          <p>
            If you’ve ever wished your kid had access to a Black history class
            without waiting for somebody else’s permission —
          </p>
          <p>
            If you ever felt the weight of being a stone the builder
            refused —
          </p>
          <p className="story-emphasis">
            This was made for you.
          </p>

          <p>
            Get the book. Tell three friends. Light the fuse.
          </p>

          <p className="story-emphasis">Welcome to AAX. This is just the start.</p>

          <p className="story-byline-end">
            <b>N.J. Griffin</b>
            <br />
            <span>Founder · African American Xperience</span>
            <br />
            <span>Morris College · Criminal Justice &amp; Psychology</span>
          </p>

          <div className="story-ctas">
            <a
              href="/#buy"
              className="btn btn-gold btn-lg"
              data-testid="story-buy-btn"
            >
              <ShoppingCart size={18} /> Get Volume I · $1 digital / $24.99 print
            </a>
            <Link
              to="/"
              className="btn btn-outline btn-lg"
              data-testid="story-home-btn"
            >
              See the 50 names
            </Link>
          </div>

          <StoryShare />
        </article>

        <ContactSection />
      </main>

      <footer className="story-footer">
        <p>
          AfricanAmericanXperience.com · Stones the Builder Refused · Volume I of V
        </p>
        <p className="story-footer-scripture">
          <em>
            ”The stone the builder refused has become the chief cornerstone.”
          </em>{" "}
          — Psalm 118:22
        </p>
      </footer>
    </div>
  );
}
